module.exports = __webpack_public_path__ + "static/media/Mask group.08a0d13d.svg";